import React, { useState,useEffect, useCallback } from "react";
import {createSearchParams, useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { callLSQLapp, getLsqLeadBody, DataLayerEvent } from "../services/lsq";
import queryString from "query-string";
function Form() {
  let navigate = useNavigate();
  const [detailOne, setDetailOne] = useState(true);
  const [detailTwo, setDetailTwo] = useState(false);
  const [errors, setErrors] = useState({});
  const [checked, setChecked] = useState(true);
  const [newMargin, setNewMargin] = useState(false);
  const [otpstatus, setOtpstatus] = useState(1);

  //lsq
  const [token, setToken] = useState("");
  // icici states
  const [solId, setSolid] = useState("");
  const [fbp, setFbp] = useState("");
  const [fbc, setFbc] = useState("");
  const [branchOptions, setBranchOptions] = useState([]);
  const [timerDisplay, setTimerDisplay] = useState("none");
  const [otpBtnText, setOtpBtnText] = useState("Resend");
  const [timer, setTimer] = useState(0);
  const [phoneCode, setPhoneCode] = useState(null);
  const [DisableOtpBtn, setDisableOtpBtn] = useState(false)
 // misc states
 const [cookies, setCookie] = useCookies();
 const [countryCode, setCountryCode] = useState("91");
 const [fullPhone, setFullPhone] = useState(null);
 const [creatingLead, setCreatingLead] = useState(false);
 const [otpsent, setOtpsent] = useState(false);
 const [branch, setBranch] = useState("");
  let formIsValid = true;
  let newErrors = { ...errors };
  const [inputs, setInputs] = useState({});

  const handleChange = (event) => {
    var name = event.target.name;
    var value = event.target.value;

    if (name === "name") {
      value = value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    }

    if (name === "pan") {
      value = value.replace(/\s\s+/g, " ");
      value = value.toUpperCase();
      value = value.replace(/[^a-zA-Z0-9]/g, "");

      if (value.length <= 5 && /[^a-zA-Z]/.test(value)) {
        value = value.slice(0, -1);
      }

      if (
        value.length > 5 &&
        value.length <= 9 &&
        /^[^0-9]+$/.test(value.slice(5, 9))
      ) {
        value = value.slice(0, -1);
      }

      if (value.length === 10 && /^[^a-zA-Z]/.test(value.slice(-1))) {
        value = value.slice(0, -1);
      }
    }

    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  // /! TIMER EFFECTS
  const timeOutCallback = useCallback(
    () => setTimer((currTimer) => currTimer - 1),
    []
  );
  useEffect(() => {
    if (inputs.mobile?.length > 5 && inputs.mobile?.length <= 10 && otpsent) {
      timer > 0 && setTimeout(timeOutCallback, 1000);
    }
  }, [timer, timeOutCallback, inputs.mobile, otpsent]);

  useEffect(() => {
    // console.log('mobile useEffect')
    let OTP = inputs["otp"] ? inputs["otp"] : "";
    if (inputs.mobile !== undefined) {
      // if (mobileVal.length === 10 && otpsent === false) {
      //   sendOTPText(mobileVal);
      // }

      // if (mobileVal.length !== 10) {
      //   setOtpsent(false);
      // }

      if (OTP.length === 6 && token === "") {
        // console.log("verifying num", { OTP, mobileVal });
        verifyOTPText(phoneCode, OTP);
      }
    }
  }, [token, inputs["otp"], inputs["mobile"]]);

 //? set Fbp, Fbc, UTM parameters values
 useEffect(() => {
  setFbp(cookies["_fbp"] || "");
  setFbc(cookies["_fbc"] || "");
}, []);

useEffect(() => {
  setFullPhone(`${inputs.mobile}`);
  setPhoneCode(inputs.mobile);

}, [ inputs.mobile])


const handleBranchChange = (e) => {
  const selectedBranch = e.target.value;
  const selectedSolId = e.target.options[e.target.selectedIndex].getAttribute("solid");

  setBranch(selectedBranch);
  setSolid(selectedSolId);

  // Additional logic if needed
  setInputs((inputs) => ({ ...inputs, ["branch"]: selectedBranch }));
};
  const handleBlur =async (event) => {
    var name = event.target.name;
    var regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    var mobile_reg = /^[1-9]{1}[0-9]{9}$/;
    var name_reg = /^[a-zA-Z ]*$/;
    var email_reg = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    var pincode_reg = /^[0-9]{6}$/;

    if (name === "name") {
      if (inputs.name === "" || inputs.name === undefined) {
        newErrors.name = "Please enter your name.";
        formIsValid = false;
      } else {
        if (inputs.name.trim().length <= 2) {
          newErrors.name = "Please enter valid name.";
          formIsValid = false;
        } else if (!inputs.name.match(name_reg)) {
          newErrors.name = "Please enter valid name.";
          formIsValid = false;
        } else {
          newErrors.name = "";
        }
      }
      setErrors(newErrors);
    }
    if (name === "pan") {
      if (inputs.pan === "" || inputs.pan === undefined) {
        newErrors.pan = "Please enter your PAN number.";
        formIsValid = false;
      } else {
        if (!inputs.pan.match(regpan)) {
          newErrors.pan = "Please enter valid PAN number.";
          formIsValid = false;
        } else {
          newErrors.pan = "";
        }
        
      }
      setErrors(newErrors);
    }
    if (name === "email") {
      if (inputs.email === "" || inputs.email === undefined) {
        newErrors.email = "Please enter your email.";
        formIsValid = false;
      } else {
        if (!inputs.email.match(email_reg)) {
          newErrors.email = "Please enter valid email.";
          formIsValid = false;
        } else {
          newErrors.email = "";
        }
      }
      setErrors(newErrors);
    }
    if (name === "mobile") {
      if (!inputs.mobile) {
        newErrors.mobile = "Please enter your mobile number.";
        formIsValid = false;
        setNewMargin(true);
      } else {
        if (!inputs.mobile.match(mobile_reg)) {
          newErrors.mobile = "Please enter valid mobile number.";

          formIsValid = false;
          setNewMargin(true);
        } else {
          newErrors.mobile = "";
        }
      }
      setErrors(newErrors);
    }
    if (name === "otp") {
      if (!inputs.otp) {
        formIsValid = false;
        newErrors.otp = "Please enter OTP.";
      } else {
        if (typeof inputs.otp !== "undefined" && inputs.otp.length !== 6) {
          formIsValid = false;
          newErrors.otp = "Please enter valid OTP.";
        } else {
          newErrors.otp = "";
        }
      }
      setErrors(newErrors);
    }
    if (name === "pincode") {
      if (!inputs.pincode) {
        formIsValid = false;
        newErrors.pincode = "Please enter valid pincode.";
      } else {
        if (!inputs.pincode.match(pincode_reg)) {
          newErrors.pincode = "Please enter valid pincode.";
          formIsValid = false;
        } else if (inputs.pincode.length === 6) {
          // Initialize Branch to empty when a request is initiated so the last stored option is reset to blank.
          // console.log('calling mavis lapp');
          setInputs((inputs) => ({
            ...inputs,
            ["branch"]: "",
          }));
          setSolid("");
          setBranchOptions([]);
          newErrors.pincode = "";
  
          // console.log("inputs", inputs);
          let payload = { pincode: inputs.pincode };
          let param = { type: "WBServiceablePincode" };
  
          //! CALL LAPP FOR PINCODE - BRANCHES FETCH
          let response = await callLSQLapp(payload, "MAVIS", param);
          // console.log(response,"mavis mapping response branches fetched");
  
          if (response.data.message.Count === 0 || response.data.message.Count === undefined) {
            // console.log("Please enter valid pincode");
            newErrors.pincode = "Please enter valid pincode";
  
            setNewMargin(true);
          } else {
  
            // set solid and branch
            setInputs((inputs) => ({
              ...inputs,
              ["branch"]: response.data.message.Data[0].Branch_Name,
            }));
            setBranchOptions(response.data.message.Data)
            setSolid(response.data.message.Data[0].SOLID);
            setBranchOptions(response.data.message.Data)
          }
        }
        setErrors(newErrors);
    }
  }

    if (name === "branch") {
      if (!inputs.branch) {
        newErrors.branch = "Please select branch.";
        formIsValid = false;
      } else {
        newErrors.branch = "";
      }
      setErrors(newErrors);
    }
    if (name === "need") {
      if (!inputs.need) {
        newErrors.need = "Please select need.";
        formIsValid = false;
      } else {
        newErrors.need = "";
      }
      setErrors(newErrors);
    }

    // if (name === "product") {
    //   if (!inputs.product) {
    //     newErrors.product = "Please select product.";
    //     formIsValid = false;
    //   } else {
    //     newErrors.product = "";
    //   }
    //   setErrors(newErrors);
    // }
   
  };

  const DetailsValidate =async () => {
    var email_reg = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    var name_reg = /^[a-zA-Z ]*$/;
    var mobile_reg = /^[1-9]{1}[0-9]{9}$/;

    if (
      inputs.name === "" ||
      inputs.name === undefined ||
      inputs.name.length <= 2
    ) {
      newErrors.name = "Please enter your name.";
      formIsValid = false;
    } else {
      if (!inputs.name.match(name_reg)) {
        newErrors.name = "Please enter valid name.";
        formIsValid = false;
      } else {
        newErrors.name = "";
      }
    }

    if (inputs.email === "" || inputs.email === undefined) {
      newErrors.email = "Please enter your email.";
      formIsValid = false;
    } else {
      if (!inputs.email.match(email_reg)) {
        newErrors.email = "Please enter valid  email.";
        formIsValid = false;
      } else {
        newErrors.email = "";
      }
    }

    if (!inputs.mobile) {
      newErrors.mobile = "Please enter your mobile number.";

      formIsValid = false;
    } else {
      if (!inputs.mobile.match(mobile_reg)) {
        newErrors.mobile = "Please enter valid mobile number.";
        formIsValid = false;
      } else {
        newErrors.mobile = "";
      }
    }

    var regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
    if (!inputs["pan"]) {
      newErrors.pan = "Please enter your PAN number.";
      formIsValid = false;
    } else if (!inputs["pan"].match(regpan)) {
      formIsValid = false;
      newErrors.pan = "Please enter valid PAN number.";
    } else {
      newErrors.pan = "";
    }
    setErrors(newErrors);

    if (formIsValid) {
      setDisableOtpBtn(true)
      await DataLayerEvent("generate_otp_clicked")
      await sendOTPText(phoneCode)
      setDetailTwo(true);
      setDetailOne(false);
      
    } else {
      formIsValid = false;
      return false;
    }

  }

  // ? OTP HANDLERS 
  // sendOTPText otp
  const sendOTPText = async (mobileNumber) => {
    // let mobileNumber = e.target.value;
    if (mobileNumber) {

      let payload = { mobile: mobileNumber, messageType: "otpGeneral" };
      let param = { otp: "send", productType: "NRI" };
      // console.log(payload, 'sendotpnripayload')
      const otpResponse = await callLSQLapp(payload, "OTP", param);
      // let sent = true;
      //  replace impt - otpResponse.data.message.response.sent
      if (otpResponse.data.message.response.sent) {
        // notifySuccess("OTP has been sent to your mobile number.");
        // alert("OTP has been sent to your mobile number.")
        setTimerDisplay("inline");
        setTimer(30);
        setOtpsent(true);
        setOtpstatus(1);
      } else {
        // notifyWarn("Please Resend OTP.");
        // alert("Please Resend OTP.")
        setDisableOtpBtn(false)
        setTimerDisplay("inline");
        setTimer(30);
        setOtpsent(false);
        setOtpstatus(2);
      }

      // setMobileval(mobileNumber);
    }
  };

  // verifyOTP
  const verifyOTPText = async (mobileNum, otpValue) => {
    let payload = { mobile: mobileNum, otp: otpValue };
    let param = { otp: "verify", productType: "NRI" };
    const otpVerifyResponse = await callLSQLapp(payload, "OTP", param);
    if (
      otpVerifyResponse.data.message === "Failure Occured, please check logs"
    ) {
      // notifyWarn("Invalid OTP");
      // alert("Invalid OTP")

      setInputs({ ...inputs, otp: "" })
      return;
    }
    const tokenValue =
      otpVerifyResponse.data.message.response.dataSent.UniqueID;

    setToken(tokenValue);
    inputs.otp = otpValue;
    setOtpBtnText("Verified");
    setTimer(0);

    // notifySuccess("OTP Verified Successfully.");
    // alert("OTP Verified Successfully.")
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
   
    var pincode_reg = /^[0-9]{6}$/;
    if (!inputs.otp) {
      formIsValid = false;
      newErrors.otp = "Please enter OTP.";
    } else {
      if (typeof inputs.otp !== "undefined" && inputs.otp.length !== 6) {
        formIsValid = false;
        newErrors.otp = "Please enter valid OTP.";
      } else {
        newErrors.otp = "";
      }
    }

    if (!inputs.pincode) {
      formIsValid = false;
      newErrors.pincode = "Please enter valid pincode.";
    } else {
      if (!inputs.pincode.match(pincode_reg)) {
        newErrors.pincode = "Please enter valid pincode.";
        formIsValid = false;
      } else {
        newErrors.pincode = "";
      }
    }

    if (!inputs["branch"]) {
      newErrors.branch = "Please select branch.";
      formIsValid = false;
    } else {
      newErrors.branch = "";
    }
    if (!inputs["need"]) {
      newErrors.need = "Please select need.";
      formIsValid = false;
    } else {
      newErrors.need = "";
    }

   

    if (!checked) {
      formIsValid = false;
      newErrors.terms_chk = "Please accept the terms and conditions.";
    } else {
      newErrors.terms_chk = "";
    }

    setErrors(newErrors);

    if (formIsValid) {
      await DataLayerEvent("get_in_touch_clicked")
      const utmParamsObj = queryString.parse(window.location.search);
      for (const [key, value] of Object.entries(utmParamsObj)) {
        inputs[key] = value;
      }
      let names = inputs.name.split(" ")
      let firstName = names[0];
      let  lastName = names.length > 1 ? names[names.length - 1] : "";

      inputs.firstName = firstName;
      inputs.lastName = lastName;
      inputs.ApiProductName = "Service";
      inputs.serviceType = "Senior Citizen"
      inputs.CampaignId = "833424";
      inputs.campaignRegion = "West Bengal"
      inputs.CompleteUrl = window.location.href;
      inputs.token = token;
      inputs.solId = solId;
      inputs.isChecked = checked;
      inputs.FBPixelID = fbp;
      inputs.FBClickID = fbc;
      inputs.ModeOfLead = "Landing Page";
      inputs.leadPhone = fullPhone;
// console.log("final input values", inputs);
let lsqInputs = getLsqLeadBody(inputs);
let payload = {
  mobile: phoneCode,
  otp: inputs.otp,
  formdata: lsqInputs,
};
let param = { productType: "NRI" };
// console.log(payload, param ,'--------LEadcreatepayload------');
// make changes in product type otp
// console.log(getLsqLeadBody(inputs));
setCreatingLead(true);

let createLeadResp = await callLSQLapp(payload, "CREATE", param);
// console.log(createLeadResp,'createLeadResp');
if (
  createLeadResp.data.message !== "Failure occured , please check logs"
) {
  let leadid = createLeadResp.data.message.Data.LeadApiCalls.Message.Id;
  let criffPayload = {
    Current: {
      "ProspectID": leadid,
      "FirstName": inputs.firstName,
      "LastName":  inputs.lastName,
      "mx_Pincode": inputs.pincode,
      "mx_PAN": inputs["pan"],
      "Phone": inputs["mobile"],
      "mx_City": inputs["branch"] ? inputs["branch"].split('-')[0] : ""
    }
  };
// console.log("criffPayload", criffPayload)
     // ? Call Criff Lapp
     const criffResponse = await callLSQLapp(criffPayload, "CRIF", { "requestFrom": "LP_SA" })

    //  console.log("criffResponse", criffResponse);
     let updateLeadPayload
     let updateLeadParam = {
      leadID: leadid
    }
     if( criffResponse?.data?.message?.Description &&
      criffResponse.data.message.Description.length > 0){
      updateLeadPayload = [{        
        "Attribute": "mx_Criff_Triggered", "Value": "Yes"
     },
    {
      "Attribute": "mx_Criff_Response_Message", "Value": criffResponse?.data?.message?.Description ? criffResponse?.data?.message?.Description[0] : ""
    }]
     }else {
      const criffMessage = criffResponse?.data?.message;
      const incomeSegmentScore = criffMessage?.incomeSegmentScore
      const cibilScore = criffMessage?.cibilScore
      // ? Lead Update Data
       updateLeadPayload = [{ "Attribute": "mx_Criff_Triggered", "Value": "Yes" },
      { "Attribute": "mx_cibil_score", "Value": cibilScore }, { "Attribute": "mx_income_segment_score", "Value": incomeSegmentScore }];
     }
     const updateRejectedRes = await callLSQLapp(updateLeadPayload, "UPDATE_LEAD", updateLeadParam);
     console.log("UPDATE LEAD",updateRejectedRes)
    navigate({
    pathname: `/thankyou`,
    search: createSearchParams({ leadid: leadid}).toString()
  });
} else {
  setCreatingLead(false);
  console.log("lead not created.");
  // window.location.reload();
}
 } else {
      setNewMargin(true);
      formIsValid = false;
      return false;
    }
  };

  return (
    <>
      <article
        className={`banner_section position-relative  ${
          newMargin ? "m_update" : null
        }  `}>
        <div className="banner_img ">
          <picture>
            <img
              rel="preload"
              media="(max-width:767.5px)"
              srcSet="dist/img/senior_citizen_banner_mob.webp"
              alt="ICICI Bank sr citizen banner"
              width={767}
              height={241}
              className="img-fluid d-block d-md-none"
            />
            <img
              rel="preload"
              src="dist/img/senior_citizen_banner.webp"
              alt="sr citizen banner img"
              width={1920}
              height={764}
              className="img-fluid d-none d-md-block"
            />
          </picture>
        </div>
        
       

        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-12">
              <div className="form_wrap" id="sr_citizen">
                <div className="form_heading">
                  <h4>
                    Fill in your details and our expert will connect with you
                  </h4>
                </div>
                <form name="contactForm" method="post" onSubmit={handleSubmit}>
                {detailOne === true &&
                  <section>
                  <div className="my-md-2 my-3">
                  <input
                    type="text"
                    name="name"
                    onChange={handleChange}
                    placeholder="Name"
                    onBlur={handleBlur}
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(
                        /[^a-zA-Z\s]/gi,
                        ""
                      ))
                    }
                    value={inputs.name}
                  />
                </div>
                {errors.name && <span className="error">{errors.name}</span>}
                <div className="my-md-2 my-3">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={inputs.email}
                  />
                </div>
                {errors.email && (
                  <span className="error">{errors.email}</span>
                )}
                <div className="col-12 pt-md-2  pb-md-2">
                  <input
                    type="text"
                    name="pan"
                    placeholder="PAN"
                    id="pan"
                    value={inputs.pan ? inputs.pan : ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 10))
                    }
                  />
                </div>
                {errors.pan && <span className="error">{errors.pan}</span>}

                <div className="my-md-2 my-3 position-relative">
                  <span className=" number-span ">+91 </span>
                  <input
                    type="number"
                    name="mobile"
                    id="mobile"
                    className="p_start"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Mobile Number"
                    disabled={otpBtnText === "Verified" ? true : false}
                    pattern="\d{10}"
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 10))
                    }
                    value={(inputs.mobile > 0) ? inputs.mobile.replace(/^[0-5]+/, '') : ""}
                  />
                </div>
                {errors.mobile && (
                  <span className="error">{errors.mobile}</span>
                )}
                <div className="applynow  pt-2">
                  <button type="button" onClick={DetailsValidate} disabled={DisableOtpBtn}>Generate OTP</button>
                </div>
                  </section>
                }
                {detailTwo === true &&
                  <section>
                  <div className="my-2 d-flex align-items-center  ">
                  <input
                    type="number"
                    min="0"
                    name="otp"
                    placeholder="OTP"
                    className="ms-0"
                    id="otp"
                    value={inputs.otp}
                    disabled={otpsent && otpBtnText !== "Verified" ? false : true}
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 6))
                    }
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
            {otpBtnText === "Verified" ? "" : errors.otp && <span className="error">{errors.otp}</span>}
                  {/* =========== timer and resend button start =============*/}
                <div className="btn-container">
                      {otpstatus === 1 && timer > 0 ? (
                        <div className="timer_wrapper text-center ms-1">
                          <span
                            className="Timer"
                            id="timer"
                            style={{ display: timerDisplay }}
                          >
                            {" "}
                            00:
                            {timer.toString().length < 2
                              ? timer.toString().padStart(2, "00")
                              : timer}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      {(otpstatus === 1 && timer === 0) || otpBtnText === "Verified" ? (
                        <div className="resend_btn ms-1">
                          <button disabled={otpBtnText === "Verified" ? true : false} onClick={() => { sendOTPText(phoneCode) }}>{otpBtnText}</button>
                        </div>
                      ) : (
                        <div className="resend_btn ms-1">
                          <button style={{ display: otpstatus === 1 ? 'none' : '' }} disabled={otpBtnText === "Verified" ? true : false} onClick={() => { sendOTPText(phoneCode) }}>Send OTP</button>
                        </div>
                      )}
                    </div>
                  {/* =========== timer and resend button end =============*/}
                </div>
                {errors.otp && <span className="error">{errors.otp}</span>}
               

                <div className="pt-xl-1 pt-md-2 my-3 my-md-0  pb-md-2 pe-0">
                  <input
                    className="mb-2"
                    type="number"
                    min="0"
                    placeholder="Enter a West Bengal pin code"
                    id="pincode"
                    name="pincode"
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 6))
                    }
                    value={inputs.pincode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.pincode && (
                    <span className="error">{errors.pincode}</span>
                  )}
                </div>
                <div className="col-12 ps-0  pb-md-0">
                <select
                  name="branch"
                  id="branch"
                  onChange={handleBranchChange}
                  onBlur={handleBlur}
                  value={branch}>
                    
                  {/* <option value=""> Select Branch</option> */}
                  {/* <option value="1">Branch name 1</option>
                  <option value="2">Branch name 2</option>
                  <option value="3">Branch name 3</option> */}
                   {branchOptions.length > 0 && branchOptions.map(option => (<option key={option.SOLID} value={option.Branch_Name} solid={option.SOLID}>{option.Branch_Name}</option>))}
                </select>
              </div>
              {errors.branch && (
                <span className="error">{errors.branch}</span>
              )}
              <div className=" ps-0 my-3">
                  <select
                    name="need"
                    id="need"
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <option selected value="">Your Need</option>
                    <option value="Account">Account</option>
                    <option value="FixedDeposit">Fixed Deposit</option>
                    <option value="Form15H">Form 15H</option>
                    <option value="LifeCertificate">Life Certificate</option>
                  </select>
                {errors.need && <span className="error">{errors.need}</span>}

                </div>

                

                <div className="checkbox row">
                  <div className="col-1 p-0 check-input">
                    <input
                      type="checkbox"
                      name="terms_chk"
                      id="terms_chk"
                      defaultChecked={checked}
                      onClick={() => setChecked(!checked)}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                  <div className="col-11 p-0 ">
                    <label htmlFor="terms_chk">
                      I authorise ICICI Bank and its representatives to
                      contact me through phone, email and SMS. I also agree to
                      ICICI Bank’s  <a href="https://www.icicibank.com/terms-condition?ITM=nli_cms_terms_and_conditions_footer_nav.html" style={{textDecoration:"none"}}>Terms & Conditions.</a>
                    </label>
                  </div>
                  {errors.terms_chk && (
                    <span className="error">{errors.terms_chk}</span>
                  )}
                </div>

                <div className="applynow  pt-2">
                <button
                      disabled={otpBtnText !== "Verified" || creatingLead ? true : false}
                      type="submit"
                      style={{
                        backgroundColor: otpBtnText !== "Verified" || creatingLead ? "grey" : "",
                      }}
                    >
                      {creatingLead ? "Processing" : "Get in Touch"}
                    </button>
                  {/* <button type="submit">Get in Touch</button> */}
                </div>
                  
                  </section>
                
                }
                

                 
                </form>
              </div>
            </div>
          </div>
        </div>
      </article>
    </>
  );
}

export default Form;
